/**
 * MOCK DATA — Perfil del agente + leads + landing personal
 * Secciones: Mi Perfil (/app/perfil) + Landing Personal (/agente/:id)
 * Reemplazar por: consultas a Supabase (perfiles, leads, configuración de landing)
 */
export const mockAgentProfile = {
  id: 'ml',
  name: 'Mario López',
  role: 'Agente Licenciado',
  username: 'mariolopez',
  bio: 'Apasionado por la educación financiera y el crecimiento patrimonial de la comunidad latina. Con más de 5 años de experiencia ayudando a familias a proteger su futuro y construir un legado sólido. Mi misión es que el dinero deje de ser un tabú y se convierta en una herramienta para tu libertad.',
  image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  isLandingActive: true,
};

export const mockLeads = [
  {
    id: 'l1',
    name: 'Sofía Ramírez',
    email: 'sofia.ramirez@email.com',
    phone: '(555) 123-4567',
    message: 'Hola Mario, vi tu video sobre interés compuesto y me gustaría agendar una cita para revisar mis opciones de retiro.',
    date: '16 Mar 2024',
    status: 'new'
  },
  {
    id: 'l2',
    name: 'Diego Morales',
    email: 'dmorales.88@email.com',
    phone: '(555) 987-6543',
    message: 'Me interesa saber más sobre los seguros con beneficios en vida.',
    date: '14 Mar 2024',
    status: 'contacted'
  },
  {
    id: 'l3',
    name: 'Familia Castro',
    email: 'familia.castro@email.com',
    phone: '(555) 456-7890',
    message: '',
    date: '10 Mar 2024',
    status: 'contacted'
  }
];